import {makeStyles} from "tss-react/mui";

export const useNotificationCardStyles = makeStyles()((theme) => ({
  card: {
    cursor: "pointer",
    marginBottom: theme.spacing(1),
    border: `2px solid ${theme.palette.primary.light}`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  cardRead: {
    border: "none",
  },
  cardContent: {
    padding: theme.spacing(1.5),
    "&:last-child": {
      paddingBottom: theme.spacing(1.5),
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.text.secondary,
    fontSize: 20,
  },
  meta: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  newChip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    fontSize: "0.75rem",
    height: 20,
  },
}));

export const useNotificationListStyles = makeStyles()((theme) => ({
  list: {
    padding: theme.spacing(1),
    overflowY: "auto",
    flex: 1,
  },
  loadMore: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1),
  },
  empty: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
}));

export const useNotificationDrawerStyles = makeStyles()((theme) => ({
  paper: {
    width: 400,
    maxWidth: "100vw",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));
